import React from 'react';
import { BOOKING_LINK, BOOK_LABEL } from '../data/homepage';
type BookButtonProps = {
  size?: 'md' | 'lg';
  fullWidth?: boolean;
  className?: string;
};
export function BookButton({
  size = 'lg',
  fullWidth = false,
  className = ''
}: BookButtonProps) {
  const sizing = size === 'lg' ? 'h-14 px-8 text-lg' : 'h-11 px-5 text-base';
  return <a href={BOOKING_LINK} className={`inline-flex items-center justify-center whitespace-nowrap rounded-sm bg-gold font-semibold text-navy shadow-sm transition-[background-color,transform] duration-150 ease-out hover:bg-[#d8b237] active:scale-[0.98] ${sizing} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-1" data-mp="24xthty11gywg">
      {BOOK_LABEL}
    </a>;
}